<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g>
      <rect x="33.4" y="10.95" width="33.2" height="21.2" style="fill: #fff" />
      <path
        d="M29.4,6.95l-0,29.2l41.21,0l0,-29.2l-41.21,0Zm37.2,25.2l-33.2,0l0,-21.2l33.2,0l0,21.2Z"
        style="fill: #7acfc0; fill-rule: nonzero"
      />
      <path
        d="M60.83,32.53l-27.81,0l0,-21.57l0.75,0l0,20.82l27.06,0l0,0.75Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M67.35,32.15l-1.5,0l0,-20.44l-26.4,0l0,-1.5l27.9,0l0,21.94Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M71.62,37.16l-43.24,-0l-0,-31.21l43.23,-0l-0,31.22l0.01,-0.01Zm-41.22,-2.01l39.21,-0l0,-27.19l-39.21,-0l-0,27.19Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
    </g>
    <g>
      <rect x="61.78" y="67.84" width="33.2" height="21.2" style="fill: #fff" />
      <path
        d="M57.78,63.84l0,29.2l41.21,0l0,-29.2l-41.21,0Zm37.2,25.2l-33.2,0l-0,-21.2l33.2,0l-0,21.2Z"
        style="fill: #7acfc0; fill-rule: nonzero"
      />
      <path
        d="M89.22,89.42l-27.81,0l0,-21.57l0.75,0l0,20.82l27.06,0l0,0.75Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M95.74,89.04l-1.5,0l-0,-20.44l-26.41,-0l-0,-1.5l27.91,-0l-0,21.94Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M100,94.05l-43.23,0l0,-31.22l43.23,0l0,31.22Zm-41.22,-2.01l39.21,0l0,-27.19l-39.21,0l0,27.19Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
    </g>
    <g>
      <rect x="5.01" y="67.85" width="33.2" height="21.2" style="fill: #fff" />
      <path
        d="M1.01,63.84l0,29.2l41.21,0l0,-29.2l-41.21,0Zm4,4l33.2,0l0,21.2l-33.19,0l-0,-21.2l-0.01,0Z"
        style="fill: #7acfc0; fill-rule: nonzero"
      />
      <path
        d="M38.59,89.42l-27.81,0l-0,-0.75l27.06,0l0,-20.82l0.75,0l0,21.57Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M5.76,89.04l-1.5,0l0,-21.94l27.91,-0l0,1.5l-26.41,-0l-0,20.44Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M0,62.84l43.23,0l-0,31.22l-43.23,0l0,-31.22Zm41.22,2.01l-39.21,0l0,27.19l39.21,0l0,-27.19Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
    </g>
    <g>
      <rect x="5.01" y="67.85" width="33.2" height="21.2" style="fill: #fff" />
      <path
        d="M42.22,93.05l0,-29.2l-41.21,0l0,29.2l41.21,0Zm-37.2,-25.2l33.2,0l0,21.2l-33.2,0l0,-21.2Z"
        style="fill: #7acfc0; fill-rule: nonzero"
      />
      <path
        d="M38.59,89.04l-0.75,0l0,-20.82l-27.06,0l-0,-0.75l27.81,0l0,21.57Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M32.17,89.79l-27.91,0l-0,-21.94l1.5,-0l-0,20.44l26.41,0l0,1.5Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
      <path
        d="M0,62.84l43.23,0l-0,31.22l-43.23,0l0,-31.22Zm41.22,2.01l-39.21,0l0,27.19l39.21,0l0,-27.19Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
    </g>
    <g>
      <path
        d="M79.39,49l0,13.84l-2.01,0l0,-11.84l-54.76,0l0,11.84l-2.01,0l0,-13.84l28.39,0l0,-11.84l2,0l0,11.84l28.39,0Z"
        style="fill: #fff; fill-rule: nonzero"
      />
      <path
        d="M53.01,46.99l0,-11.83l-6.03,0l0,11.83l-28.39,0l0,17.86l6.04,0l0,-11.83l50.73,0l-0,11.83l6.04,0l-0,-17.86l-28.39,0Zm26.38,15.85l-2.01,0l0,-11.83l-54.76,0l0,11.83l-2.01,0l0,-13.84l28.39,0l0,-11.83l2,0l0,11.83l28.39,0l0,13.84Z"
        style="fill: #4a4a4a; fill-rule: nonzero"
      />
    </g>
    <g id="Capa1">
      <rect
        x="37.117"
        y="19.786"
        width="25.701"
        height="1.04"
        style="fill: #4a4a4a"
      />
      <rect
        x="8.954"
        y="76.151"
        width="25.387"
        height="1.04"
        style="fill: #4a4a4a"
      />
      <rect
        x="65.571"
        y="76.156"
        width="25.633"
        height="1.04"
        style="fill: #4a4a4a"
      />
      <rect
        x="37.127"
        y="22.885"
        width="25.628"
        height="0.618"
        style="fill: #4a4a4a"
      />
      <rect
        x="8.999"
        y="79.25"
        width="25.28"
        height="0.618"
        style="fill: #4a4a4a"
      />
      <rect
        x="65.583"
        y="79.255"
        width="25.557"
        height="0.618"
        style="fill: #4a4a4a"
      />
    </g>
  </svg>
</template>
